import actionTypes from "../../actions/actionTypes";
import updateObject from "../../../utils/updateObject";

const initialState = {
  data: [],
  fetching: true,
  error: null,
  pageSize: 12,
  nextOffset: null
};

const fetch = (state, action) => {
  return updateObject(state, {
    fetching: true,
    data: [],
    error: null,
    nextOffset: null
  });
}

const fetchOk = (state, action) => {
  return updateObject(state, {
    fetching: false,
    error: null,
    data: [...state.data, ...action.data.List],
    nextOffset: action.data.NextOffset
  });
}

const fetchError = (state, action) => {
  return updateObject(state, {
    fetching: false,
    error: action.error
  });
}

const fetchMore = (state, action) => {
  return updateObject(state, {
    fetching: true
  });
}

export default function reducer(state = initialState, action) {
  switch(action.type) {
    case actionTypes.invoices.FETCH:
      return fetch(state, action);
    case actionTypes.invoices.FETCH_OK:
      return fetchOk(state, action);
    case actionTypes.invoices.FETCH_ERROR:
      return fetchError(state, action);
    case actionTypes.invoices.FETCH_MORE:
      return fetchMore(state, action);
    default:
      return state;
  }
}